import React from 'react';
import TitleWithHint from '../../components/TitleWithHint';

const OverviewPanel = ({ title, hint, icon, children }) => (
  <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-6">
    <div className="flex items-center gap-2">
      {icon}
      <h3 className="text-base sm:text-lg font-medium text-gray-700">
        {hint ? <TitleWithHint title={title} hint={hint} /> : title}
      </h3>
    </div>
    {children}
  </div>
);

export default OverviewPanel;
